import { useEffect, useState } from "react"
import { getProjectTrends } from "../api/ProjectTrends"
import { ProjectTrends } from "../Interface/Trends"

/**
 * Hook to fetch the Project Trends data from the API
 * 
 * Use loading state to show a loading spinner
 * Use error state to show an error message if the data is not fetched correctly
 * 
 * @returns The Project Trends data from the API
 */
export function useProjectTrends() {
    const [data, setData] = useState<ProjectTrends[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const fetchData = async () => {
        setIsLoading(true)
        setError(null)

        const response = await getProjectTrends()
        if (response && response.operation == "COMPLETED") {
            setData(response.data)
        } else {
            if (response && response.operation == "ERROR") {
                setError(response.message)
            } else {
                setError("An unknown error occurred")
            }
        }

        setIsLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    return {
        data,
        isLoading,
        error,
    }
}